import { NgModule } from '@angular/core'; 
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular'; 
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// mis npms
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FormsModule, FormBuilder } from  '@angular/forms';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
// import { Firebase } from '@ionic-native/firebase/ngx';
//import { FCM } from '@ionic-native/fcm/ngx';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { ipRoot } from './services/bodyAll';
const config: SocketIoConfig = { url: ipRoot, options: {} }; 
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { Media } from '@awesome-cordova-plugins/media/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Chooser  } from '@awesome-cordova-plugins/chooser/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
//import { DomSanitizer } from '@angular/platform-browser';
//import { Base64 } from '@ionic-native/base64/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

//conect http herrors 
import { TokenInterceptor } from './inteceptors/token.interceptor';
import { OpcionProfileComponent } from './components/opcion-profile/opcion-profile.component';
import { EmojiPickerComponent } from './components/emoji-picker/emoji-picker.component';
import { P2pMethodComponent } from './components/p2p-method/p2p-method.component'
import { CurrenciesPage } from './pages/p2p/currencies/currencies.page'
import { MethodsPage } from './pages/p2p/methods/methods.page'
import { PolitiesComponent } from './components/polities/polities.component';
import { LoginCoinbaseComponent } from './pages/login-coinbase/login-coinbase.component';
//import { OrderPage } from './pages/p2p/orders/order/order.page'

// import { MenuPageModule } from './pages/menu/menu.module';
// import { MenuPage } from './pages/menu/menu.page';
// import { ContactComponent } from './modals/contact/contact.component';
//crypto
import { AES256 } from '@awesome-cordova-plugins/aes-256/ngx';
import {MatExpansionModule} from '@angular/material/expansion';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';

import { TotalPipe } from './pipes/total.pipe';
import { AcumPipe } from './pipes/acum.pipe';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
} 

@NgModule({
  declarations: [
    AppComponent, 
    OpcionProfileComponent, 
    EmojiPickerComponent, 
    P2pMethodComponent, 
    CurrenciesPage, 
    MethodsPage, 
    TotalPipe, 
    AcumPipe,
    //OrderPage,
    PolitiesComponent,
    LoginCoinbaseComponent,
  ],
  entryComponents: [AppComponent, OpcionProfileComponent, EmojiPickerComponent, P2pMethodComponent, CurrenciesPage, MethodsPage],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    IonicStorageModule.forRoot({
      name: '__mydb',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
    }),
    HttpClientModule,
    SocketIoModule.forRoot(config),
    PickerModule,
    AppRoutingModule
  ],
  providers: [
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS,  useClass: TokenInterceptor, multi: true },
    FormBuilder,
    // FCM,
    BarcodeScanner,
    // MenuPageModule,
    Media,
    HTTP,
    File,
    FilePath,
    LocalNotifications,
    InAppBrowser,
    FileTransfer,
    Camera,
    Chooser,
    FileOpener,
    MatExpansionModule,
    AES256,
    SocialSharing,
    QRCodeModule,
    NgxScannerQrcodeModule,
    //DomSanitizer,
    //Base64,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
